<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['order.no']" placeholder="placeholder.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['commandId']" placeholder="placeholder.commandId" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query['commandStatus']" :options="commandStatus" placeholder="placeholder.commandStatus" @change="refresh"/>
        <vxe-input v-model="query['item.no']" placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.name']" placeholder="placeholder.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.mnemonicCode']" placeholder="placeholder.mnemonicCode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['lot.no']" placeholder="placeholder.lotNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="query.range" clearable linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table ref="table" :data="data" :export-config="{}" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="command.id" title="business.label.commandId" width="120"/>
        <vxe-column field="command.addTime" sortable title="business.label.addTime" width="170"/>
        <vxe-column field="inspectTime" sortable title="business.label.inspectTime" width="170"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:commandStatus}" field="command.commandStatus" sortable title="business.label.dataSource" width="120"/>
        <vxe-column field="order.no" sortable title="business.label.orderNo" width="120"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="120"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:packTypes}" field="command.packType" sortable title="business.label.packType" width="120"/>
        <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="120"/>
        <vxe-column field="lot.no" sortable title="business.label.lotNo" width="120"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="container.no" sortable title="business.label.containerNo" width="90"/>
        <vxe-column field="command.allocateQuantity" title="business.label.allocateQuantity" width="120"/>
        <vxe-column field="allocateLocation.no" title="business.label.allocateLocation" width="120"/>
        <vxe-column field="putawayLocation.no" title="business.label.putawayLocation" width="120"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="120"/>
        <vxe-column field="command.putawayQuantity" title="business.label.putawayQuantity" width="120"/>
        <vxe-column field="asnOrder.operator" title="business.label.operator" width="120"/>
        <vxe-column field="receivingman" title="business.label.receivingman" width="120"/>
        <vxe-column field="inspector" title="business.label.inspector" width="120"/>
        <vxe-column field="putaway.shelver" title="business.label.shelver" width="120"/>
        <vxe-column field="putaway.shelvingTime" sortable title="business.label.shelvingTime" width="170"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="refundable" title="business.label.refundable" width="70"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import moment from 'moment'
import { getEnums } from '@/utils/util'

export default {
  name: 'ContainerCommandQuery',
  data() {
    return {
      loading: false,
      data: [],
      query: {
        'order.no': '',
        commandId: '',
        commandStatus: undefined,
        'item.no': '',
        'item.name': '',
        'item.mnemonicCode': '',
        'lot.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
      commandStatus: [],
      packTypes: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  created() {
    getEnums('CommandStatus').then(result => {
      this.commandStatus = result
      return getEnums('PackType')
    }).then(result => {
      this.packTypes = result
    })
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.range.length > 0) {
        args['commandDateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['commandDateFilter'] = null
      }
      findAll('containerCommandFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'order.no': '',
        commandId: '',
        commandStatus: undefined,
        'item.no': '',
        'item.name': '',
        'item.mnemonicCode': '',
        'lot.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>